import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button"];
  static classes = ["active"];

  static values = {
    activeClasses: { type: String, default: "border-brand-500 bg-brand-50 text-brand-700" },
    inactiveClasses: { type: String, default: "border-surface-border text-content-muted" }
  };

  connect() {
    this.frame = document.getElementById("exercise_form_area");
    if (this.frame) {
      this.frame.addEventListener("turbo:frame-load", this.#onFrameLoad);
    }
  }

  disconnect() {
    if (this.frame) {
      this.frame.removeEventListener("turbo:frame-load", this.#onFrameLoad);
    }
  }

  select(event) {
    this.buttonTargets.forEach((btn) => {
      this.#deactivate(btn);
    });
    this.#activate(event.currentTarget);
  }

  #scrollDown() {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  }

  #onFrameLoad = () => {
    const hasForm = this.frame.querySelector("form");
    if (hasForm) {
      this.#scrollDown();
    } else {
      this.buttonTargets.forEach((btn) => this.#deactivate(btn));
    }
  };

  #activate(el) {
    this.inactiveClassesValue.split(" ").forEach((c) => el.classList.remove(c));
    this.activeClassesValue.split(" ").forEach((c) => el.classList.add(c));
  }

  #deactivate(el) {
    this.activeClassesValue.split(" ").forEach((c) => el.classList.remove(c));
    this.inactiveClassesValue.split(" ").forEach((c) => el.classList.add(c));
  }
}
